import React, { Component } from 'react';
import DownIcon from '../../../assets/svg/arrow-ios-downward.svg';
import UpIcon from '../../../assets/svg/upward-arrow.svg';
class EquipmentsSummary extends Component {
	constructor() {
		super();
		this.state = {
			myArray: {},
		};
	}
	componentDidMount = () => {
		// if (this.props.data.length !== 0) {
		//     this.props.data[0].isExpanded = false
		// }
	};
	getModelName = (obj, i) => {
		let resarray = [];
		Object.keys(obj).forEach(function (key, index) {
			let temparray = [];
			temparray.push(key);
			temparray.push(obj[key].busy + obj[key].ready);
			temparray.push(obj[key].ready);
			temparray.push(obj[key].busy);
			resarray.push(temparray);
		});
		this.setState({
			myArray: {
				...this.state.myArray,
				[i]: resarray,
			},
		});
	};
	render() {
		return (
			<div
				className="main-bod"
				style={{
					width: '35vw',
				}}
			>
				<table
					className="equipmentsSumaryTable"
					style={{
						borderLeft: '0.5px solid  #383838',
						borderTop: '0.5px solid  #383838',
						color: 'white',
						width: '35vw',
					}}
				>
					<tr>
						<th>Type</th>
						<th>Total</th>
						<th>Ready</th>
						<th>Busy</th>
					</tr>
					{this.props.data.map((el, i) => {
						return (
							<>
								<tr style={{ textAlign: 'center' }}>
									<td
										style={{
											display: 'flex',
											gap: '10px',
											// textTransform: 'uppercase',
										}}
									>
										{' '}
										{el.isExpanded === true ? (
											<img
												onClick={() => {
													el.isExpanded = false;
												}}
												style={{
													height: '20px',
													width: '20px',
													cursor: 'pointer',
												}}
												src={UpIcon}
												alt=""
											/>
										) : (
											<img
												onClick={() => {
													el.isExpanded = true;
													this.getModelName(el.typeModels, i);
												}}
												style={{
													height: '20px',
													width: '20px',
													cursor: 'pointer',
												}}
												src={DownIcon}
												alt=""
											/>
										)}{' '}
										{el.type.charAt(0).toUpperCase() +
											el.type.replace(/([A-Z])/g, ' $1').slice(1)}
										{/* {el.type} */}
									</td>
									<td>{el.total}</td>
									<td
										style={{
											color: '#479A5F',
										}}
									>
										{el.readyCount}
									</td>
									<td style={{ color: '#F8532B' }}>{el.assignedCount}</td>
								</tr>
								{el.isExpanded === true ? (
									<>
										{this.state.myArray[i].map((el) => {
											return (
												<tr>
													<td
														style={{
															color: '#B0B0B0',
															paddingLeft: '42px',
														}}
													>
														{el[0]}
													</td>
													<td
														style={{
															textAlign: 'center',
														}}
													>
														{el[1]}
													</td>
													<td
														style={{
															color: '#479A5F',
															textAlign: 'center',
														}}
													>
														{el[2]}
													</td>
													<td
														style={{
															color: '#F8532B',
															textAlign: 'center',
														}}
													>
														{el[3]}
													</td>
												</tr>
											);
										})}
									</>
								) : (
									<></>
								)}
							</>
						);
					})}
				</table>
			</div>
		);
	}
}
export default EquipmentsSummary;
